import React, { useState,useEffect, useRef } from "react";
import { isHTML } from "../../../../../utils/helpers";
export default function ConfirmImmediateSession({ deleteUser,cancelRequest, id  }) {

  return (
    <div className="confirm-delete-wrapper cancelation-popup-show register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>Confirm you are available for an immediate session</h3>
             
              <div className="confirm-btn-box cancelation-popup-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  Cancel
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={deleteUser}
                >
                  Confirm
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
